import id_companyProfile from "../../page/company_profile/language/id_companyProfile"
import id_dashboard from "../../page/dashboard/language/id_dashboard"
import id_login from "../../page/login/language/id_login"
import id_master_attribute from "../../page/master/attribute/language/id_master_attribute"
import id_master_bankaccount from "../../page/master/bank_account/language/id_master_bankaccount"
import id_master_convertion from "../../page/master/conversion/language/id_master_convertion"
import id_master_courier from "../../page/master/courier/language/id_master_courier"
import id_master_customer from "../../page/master/customer/language/id_master_customer"
import id_master_finance from "../../page/master/finance/language/id_master_finance"
import id_master_goods from "../../page/master/goods/language/id_master_goods"
import id_master_goodsPrice from "../../page/master/goods/price/language/id_master_goodsPrice"
import id_master_goodsPriceTier from "../../page/master/goods/price_tier/language/id_master_goodsPriceTier"
import id_master_groups from "../../page/master/grouping/language/id_master_groups"
import id_master_itemtag from "../../page/master/item_tag/language/id_master_itemtag"
import id_master_payment_method from "../../page/master/payment_method/language/id_master_payment_method"
import id_master_price_tier from "../../page/master/price_tier/language/id_master_price_tier"
import id_master_process from "../../page/master/process/language/id_master_process"
import id_master_profile from "../../page/master/profile/language/id_master_profile"
import id_master_sales from "../../page/master/sales/language/id_master_sales"
import id_master_supplier from "../../page/master/supplier/language/id_master_supplier"
import id_master_tnc_setting from "../../page/master/tnc_setting/language/id_master_tnc_setting"
import id_master_category from "../../page/master/unit_category/language/id_master_category"
import id_master_unit from "../../page/master/unit_category/language/id_master_unit"
import id_master_user from "../../page/master/user/language/id_master_user"
import id_master_storage from "../../page/master/warehouse/language/id_master_storage"
import id_master_whs_setting from "../../page/master/warehouse/language/id_master_whs_setting"
import id_mitra from "../../page/mitra/language/id_mitra"
import id_mitra_list from "../../page/mitra/list/language/id_mitra_list"
import id_mitra_stock_req from "../../page/mitra/stock_request/language/id_mitra_stock_req"
import id_payment_credit from "../../page/payment/credit/language/id_payment_credit"
import id_payment_debit from "../../page/payment/debit/language/id_payment_debit"
import id_purch_invoice from "../../page/purchase/invoice/language/id_purch_invoice"
import id_purch_po from "../../page/purchase/po/language/id_purch_po"
import id_purch_poMitra from "../../page/purchase/po_mitra/language/id_purch_poMitra"
import id_purch_quotation from "../../page/purchase/quotation/language/id_purch_quotation"
import id_purch_quotationMitra from "../../page/purchase/quotation_mitra/language/id_purch_quotationMitra"
import id_purch_quotationSales from "../../page/purchase/quotation_sales/language/id_purch_quotationSales"
import id_purch_recap from "../../page/purchase/recap/language/id_purch_recap"
import id_sales_refItemIn from "../../page/purchase/ref_item_in/language/id_sales_refItemIn"
import id_purch_returnsupplier from "../../page/purchase/return_supplier/language/id_purch_returnsupplier"
import id_common_report from "../../page/report/language/id_common_report"
import id_rka_planning from "../../page/rka/planning/language/id_rka_planning"
import id_sales_invoice from "../../page/sales/invoice/language/id_sales_invoice"
import id_sales_po from "../../page/sales/po/language/id_sales_po"
import id_sales_priceStock from "../../page/sales/price_stock_list/language/id_sales_priceStock"
import id_salesPriceStock from "../../page/sales/price_stock_list/language/id_sales_priceStock"
import id_sales_quotation from "../../page/sales/quotation/language/id_sales_quotation"
import id_sales_quotationMitra from "../../page/sales/quotation_mitra/language/id_sales_quotationMitra"
import id_sales_recap from "../../page/sales/recap/language/id_sales_recap"
import id_sales_refItemOut from "../../page/sales/ref_item_out/language/id_sales_refItemOut"
import id_sales_returncustomer from "../../page/sales/return_customer/language/id_sales_returncustomer"
import id_sales_so from "../../page/sales/so/language/id_sales_so"
import id_supplychain_distributionPoint from "../../page/supplychain/distribution_point/language/id_supplychain_distributionPoint"
import id_supplychain_itemReq from "../../page/supplychain/item_request/language/id_supplychain_itemReq"
import id_supplychain_do from "../../page/supplychain/language/id_supplychain_do"
import id_template from "../../page/template/language/id_template"
import id_trans_convertion from "../../page/transaction/conversion/language/id_trans_convertion"
import id_transHistory from "../../page/transaction/history/language/id_transHistory"
import id_trans_initstock from "../../page/transaction/init_stock/language/id_trans_initstock"
import id_trans_itemin from "../../page/transaction/item_in/language/id_trans_itemin"
import id_trans_itemmove from "../../page/transaction/item_move/language/id_trans_itemmove"
import id_trans_itemout from "../../page/transaction/item_out/language/id_trans_itemout"
import id_trans_common from "../../page/transaction/language/id_trans_common"
import id_trans_iteminlist from "../../page/transaction/list_item_in/language/id_trans_iteminlist"
import id_trans_itemoutlist from "../../page/transaction/list_item_out/language/id_trans_itemoutlist"
import id_trans_production from "../../page/transaction/production/language/id_trans_production"
import id_trans_returncuslist from "../../page/transaction/return_customer/language/id_trans_returncuslist"
import id_trans_returnsuplist from "../../page/transaction/return_supplier/language/id_trans_returnsuplist"
import id_trans_stockopname from "../../page/transaction/stock_opname/language/id_trans_stockopname"
import id_whs_itemin from "../../page/warehouse/item_in/language/id_whs_itemin"
import id_whs_itemmove from "../../page/warehouse/item_move/language/id_whs_itemmove"
import id_whs_itemout from "../../page/warehouse/item_out/language/id_whs_itemout"
import id_whs_itemstock from "../../page/warehouse/item_stock/language/id_whs_itemstock"
import id_whs_returncus from "../../page/warehouse/return_customer/language/id_whs_returncus"
import id_whs_returnsup from "../../page/warehouse/return_supplier/language/id_whs_returnsup"
import id_whs_serialnumber from "../../page/warehouse/serial_number/language/id_whs_serialnumber"
import id_whs_goodsdetail from "../../page/warehouse/warehouse_goods_detail/language/id_whs_goodsdetail"
import id_common from "./common/common_id"
import common_error_id from "./common_error/common_error_id"
import common_message_id from "./common_message/common_message_id"

const main_id_language = {
	translation: {
		common: id_common,
		common_error: common_error_id,
		common_msg: common_message_id,
		common_report: id_common_report,

		company_profile: id_companyProfile,
		crop_img: { crop: "crop", ok: "potong gambar" },
		dashboard: id_dashboard,
		login: id_login,

		menu: {
			dashboard: "beranda",
			warehouse: "cek gudang",
			whstrans: "transaksi gudang",
			master: "pengaturan",
			sales: "penjualan",
			ecommerce: "toko online",
			ecommregister: "pendaftaran 1Toko",
			ecommlist: "daftar toko online",
			payment: "pembayaran",
			purchase: "pembelian",
			supplychain: "rantai pasokan",
			supplychain_point: "titik distribusi",
			supplychain_request: "permintaan barang",
			report: "laporan",
			rka: "perencanaan & anggaran",
			groups: "kelompok item",
		},


		// mitra
		mitra: id_mitra,
		mitra_list: id_mitra_list,
		mitra_stock_req: id_mitra_stock_req,

		// master
		master_attribute: id_master_attribute,
		master_bankaccount: id_master_bankaccount,
		master_category: id_master_category,
		master_convertion: id_master_convertion,
		master_courier: id_master_courier,
		master_customer: id_master_customer,
		master_finance: id_master_finance,
		master_goods: id_master_goods,
		master_goodsPrice: id_master_goodsPrice,
		master_goodsPriceTier: id_master_goodsPriceTier,
		master_groups: id_master_groups,
		master_itemtag: id_master_itemtag,
		master_payment_method: id_master_payment_method,
		master_price_tier: id_master_price_tier,
		master_process: id_master_process,
		master_profile: id_master_profile,
		master_supplier: id_master_supplier,
		master_storage: id_master_storage,
		master_tncsetting: id_master_tnc_setting,
		master_unit: id_master_unit,
		master_user: id_master_user,
		master_sales: id_master_sales,
		master_whssetting: id_master_whs_setting,
		master: {
			sales: {
				add: "tambah sales",
				edit: "ubah sales",
			},
			brand: {
				// "": "brand",
				// "name": "nama brand",
				// add: "tambah brand",
				// edit: "tambah brand",
				"": "principal",
				"name": "nama principal",
				add: "tambah principal",
				edit: "ubah principal",
			}
		},

		// contract
		spal: {
			addspal: "tambah kontrak",
			editspal: "ubah kontrak",
			addpaymentmethod: "tambah cara pembayaran ( kontrak )",
			editpaymentmethod: "ubah cara pembayaran ( kontrak )",
			addtime: "tambah waktu bongkar & muat ( kontrak )",
			edittime: "ubah waktu bongkar & muat ( kontrak )",
			adddemurrage: "tambah denda keterlambatan  ( kontrak )",
			editdemurrage: "ubah denda keterlambatan ( kontrak )",
			form: {
				paymentmethod: "cara pembayaran",
				demurrage: "denda keterlambatan",
				time: "waktu bongkar & muat",
			},
		},

		// supplychain
		supplychain_distributionPoint: id_supplychain_distributionPoint,
		supplychain_do: id_supplychain_do,
		supplychain_itemReq: id_supplychain_itemReq,

		// transaction
		trans_common: id_trans_common,
		trans_convertion: id_trans_convertion,
		trans_history: id_transHistory,
		trans_initstock: id_trans_initstock,
		trans_itemin: id_trans_itemin,
		trans_iteminlist: id_trans_iteminlist,
		trans_itemmove: id_trans_itemmove,
		trans_itemout: id_trans_itemout,
		trans_itemoutlist: id_trans_itemoutlist,
		trans_production: id_trans_production,
		trans_returncuslist: id_trans_returncuslist,
		trans_returncuslist: id_trans_returncuslist,
		trans_returnsuplist: id_trans_returnsuplist,
		trans_stockopname: id_trans_stockopname,

		// sales
		sales_invoice: id_sales_invoice,
		sales_po: id_sales_po,
		sales_priceStock: id_sales_priceStock,
		sales_recap: id_sales_recap,
		sales_refItemOut: id_sales_refItemOut,
		sales_returncustomer: id_sales_returncustomer,
		sales_so: id_sales_so,
		sales_quotation: id_sales_quotation,
		sales_quotationMitra: id_sales_quotationMitra,

		// purch
		purch_invoice: id_purch_invoice,
		purch_po: id_purch_po,
		purch_poMitra: id_purch_poMitra,
		purch_recap: id_purch_recap,
		sales_refItemIn: id_sales_refItemIn,
		purch_returnsupplier: id_purch_returnsupplier,
		purch_quotation: id_purch_quotation,
		purch_quotationMitra: id_purch_quotationMitra,
		purch_quotationSales: id_purch_quotationSales,

		// payment
		payment_credit: id_payment_credit,
		payment_debit: id_payment_debit,

		// rka
		rka_planning: id_rka_planning,

		// template
		template: id_template,

		// warehouse
		whs_itemin: id_whs_itemin,
		whs_itemmove: id_whs_itemmove,
		whs_itemout: id_whs_itemout,
		whs_itemstock: id_whs_itemstock,
		whs_returncus: id_whs_returncus,
		whs_returnsup: id_whs_returnsup,
		whs_serialnumber: id_whs_serialnumber,
		whs_goodsdetail: id_whs_goodsdetail,
	},
}

export default main_id_language
